export class MainMenuEvents {
	public static readonly MAIN_MENU_OPEN: string = 'MainMenuEvents::MAIN_MENU_OPEN';
	public static readonly MAIN_MENU_CLOSED: string = 'MainMenuEvents::MAIN_MENU_CLOSED';
	public static readonly MAIN_MENU_CLOSE_CLICKED: string = 'MainMenuEvents::MAIN_MENU_CLOSE_CLICKED';

	public static readonly MAIN_MENU_SETTINGS_OPEN: string = 'MainMenuEvents::MAIN_MENU_SETTINGS_OPEN';
	public static readonly MAIN_MENU_INFO_OPEN: string = 'MainMenuEvents::MAIN_MENU_RULES_OPEN';
	public static readonly MAIN_MENU_PAYTABLE_OPEN: string = 'MainMenuEvents::MAIN_MENU_PAYTABLE_OPEN';
	public static readonly MAIN_MENU_LOBBY_OPEN: string = 'MainMenuEvents::MAIN_MENU_LOBBY_OPEN';

	public static readonly MAIN_MENU_SETTINGS_CLOSE: string = 'MainMenuEvents::MAIN_MENU_SETTINGS_CLOSE';
	public static readonly MAIN_MENU_INFO_CLOSE: string = 'MainMenuEvents::MAIN_MENU_RULES_CLOSE';
	public static readonly MAIN_MENU_PAYTABLE_CLOSE: string = 'MainMenuEvents::MAIN_MENU_PAYTABLE_CLOSE';
	public static readonly MAIN_MENU_LOBBY_CLOSE: string = 'MainMenuEvents::MAIN_MENU_LOBBY_CLOSE';

	public static readonly MAIN_MENU_SETTINGS_CLICKED: string = 'MainMenuEvents::MAIN_MENU_SETTINGS_CLICKED';
	public static readonly MAIN_MENU_INFO_CLICKED: string = 'MainMenuEvents::MAIN_MENU_RULES_CLICKED';
	public static readonly MAIN_MENU_PAYTABLE_CLICKED: string = 'MainMenuEvents::MAIN_MENU_PAYTABLE_CLICKED';
	public static readonly MAIN_MENU_LOBBY_CLICKED: string = 'MainMenuEvents::MAIN_MENU_LOBBY_CLICKED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents.ts